console.log('[SkinBetter] Script loaded');
console.log('[SkinBetter] window.customerData:', window.customerData);

// Simple SkinBetter access control - override Quotify for approved customers
if (window.customerData) {
  console.log('[SkinBetter] Customer data exists');
  console.log('[SkinBetter] Customer tags:', window.customerData.tags);
  console.log('[SkinBetter] hasSkinbetterAccess flag:', window.customerData.hasSkinbetterAccess);

  if (window.customerData.tags) {
    // Check if customer has the approved tag (case-insensitive)
    const hasSkinBetterAccess = window.customerData.tags.some(tag => {
      console.log('[SkinBetter] Checking tag:', tag, 'vs skinbetter-approved');
      return tag.toLowerCase() === 'skinbetter-approved';
    });

    console.log('[SkinBetter] Has access?', hasSkinBetterAccess);

    if (hasSkinBetterAccess) {
      console.log('[SkinBetter] Adding CSS override');

      // Override Quotify's CSS to show add to cart
      const style = document.createElement('style');
      style.textContent = `
        /* Show native add to cart buttons */
       body form[action^="/cart/add"] [data-shopify="payment-button"],
        body form[action^="/cart/add"] button[type="submit"],
        body [class*="quotify-hide-cart"] {
          display: block !important;
        }

        /* Hide Quotify elements */
        [id*="quotify_button"],
        .quotify-request-quote-btn,
        .quotify-quote-cart-btn,
        quotify-button {
          display: none !important;
        }
      `;
      document.head.appendChild(style);

      console.log('[SkinBetter] CSS override added - Quotify should be hidden');
    } else {
      console.log('[SkinBetter] No access - customer does not have SkinBetter-Approved tag');
    }
  } else {
    console.log('[SkinBetter] No tags found on customer');
  }
} else {
  console.log('[SkinBetter] No customer data found');
}